import React, { memo } from 'react'

export const ThumbsDownTooltip = memo(() => (
    <div className="thumbs-down-tooltip">
        Please edit or get a new question until you can approve this. The lesson will not be ready unless this is complete.
    </div>
))

export default ThumbsDownTooltip